
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/get-started/select-menu",
      function () {
        return require("private-next-pages/[brand]/get-started/select-menu.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/get-started/select-menu"])
      });
    }
  